import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_PENDING_TEAM_INVITATIONS, GET_WORKSPACE_INVITATIONS } from '../../contracts';
import { declineTeamInvitation } from '../api/teams';

export interface DeclineTeamInvitationVariables {
  teamId: string;
}

/**
 * Deletes the caller's invitation to one team. Idempotent server-side, so a retry
 * or declining an already-gone invitation still succeeds.
 */
export function useMutateDeclineTeamInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: DeclineTeamInvitationVariables) => {
      return await declineTeamInvitation(variables.teamId);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [GET_PENDING_TEAM_INVITATIONS] });
      // The switcher lists the same invitation, so it goes stale on the same call.
      void queryClient.invalidateQueries({ queryKey: [GET_WORKSPACE_INVITATIONS] });
    },
  });
}
